import { render } from "./logList.vue?vue&type=template&id=3e8bff06&scoped=true"
import script from "./logList.vue?vue&type=script&lang=js"
export * from "./logList.vue?vue&type=script&lang=js"

import "./logList.vue?vue&type=style&index=0&id=3e8bff06&scoped=true&lang=css"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8bff06"]])

export default __exports__